import 'react';
import '../types/props.js';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import Flex from 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import 'reakit/Portal';
import '../Portal/styled.js';
import '../Portal/index.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Backdrop';
import '../Backdrop/styled.js';
import '../Backdrop/index.js';
import '../chunk-5c9bbccf.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Container/styled.js';
import { a as Container } from '../chunk-cfb51aee.js';
import '../Container/index.js';
import 'reakit/Sidebar';
import '../Sidebar/SidebarContainer.js';
import '../Sidebar/styled.js';
import '../Sidebar/SidebarClose.js';
import '../Sidebar/SidebarHide.js';
import '../Sidebar/SidebarShow.js';
import { a as _Sidebar } from '../chunk-3ccbd0d4.js';
import '../Sidebar/index.js'; // @ts-ignore

var getWidth = function getWidth(props) {
  if (props.isMinimized) {
    return theme('fannypack.Page.WithSidebar.minimizedSidebarWidth')(props);
  }

  return props.sidebarWidth || theme('fannypack.Page.WithSidebar.sidebarWidth')(props);
};

var PageContent = styled(Container).withConfig({
  displayName: "styled__PageContent",
  componentId: "sc-1wthesb-0"
})(["padding:", "rem ", "rem;@media (max-width:", "px){padding-top:", "rem;padding-bottom:", "rem;&{", ";}}", " &{", ";}"], space(4, 'major'), space(2, 'major'), theme('fannypack.layout.tabletBreakpoint'), space(2, 'major'), space(2, 'major'), theme('fannypack.Page.Content.mobile'), function (props) {
  return props.isFluid && css(["padding:", "rem ", ";&{", ";}"], space(2, 'major'), theme('fannypack.Container.fluidMargin'), theme('fannypack.Page.Content.fluid'));
}, theme('fannypack.Page.Content.base'));
var PageContentWrapper = styled(Box).withConfig({
  displayName: "styled__PageContentWrapper",
  componentId: "sc-1wthesb-1"
})(["&{", ";}"], theme('fannypack.Page.Content.wrapper'));
var Spacer = styled(Box).withConfig({
  displayName: "styled__Spacer",
  componentId: "sc-1wthesb-2"
})(["width:", ";min-width:", ";", ";@media screen and (max-width:", "px){width:0px;min-width:0px;&{", ";}}", " &{", ";}"], getWidth, getWidth, function (props) {
  return !props.isVisible && css(["display:none;"]);
}, function (props) {
  return theme("fannypack.layout." + _get(props, 'theme.fannypack.Page.collapseBreakpoint') + "Breakpoint");
}, theme('fannypack.Page.WithSidebar.Spacer.mobile'), function (props) {
  return props.hideSidebarOnDesktop && css(["width:0px;min-width:0px;"]);
}, theme('fannypack.Page.WithSidebar.Spacer.base'));
var Sidebar = styled(Box).withConfig({
  displayName: "styled__Sidebar",
  componentId: "sc-1wthesb-3"
})(["background-color:", ";height:100vh;min-width:", ";width:", ";overflow-y:auto;transform:translateX(0px);", " &{", ";}"], palette('white700'), getWidth, getWidth, function (props) {
  return props.isMinimized && css(["overflow:visible;"]);
}, theme('fannypack.Page.WithSidebar.Sidebar.base'));
var DesktopSidebarWrapper = styled(Box).withConfig({
  displayName: "styled__DesktopSidebarWrapper",
  componentId: "sc-1wthesb-4"
})(["position:fixed;", " @media screen and (max-width:", "px){display:none;}&{", ";}"], function (props) {
  return !props.isVisible && css(["display:none;"]);
}, function (props) {
  return theme("fannypack.layout." + _get(props, 'theme.fannypack.Page.collapseBreakpoint') + "Breakpoint");
}, theme('fannypack.Page.WithSidebar.DesktopSidebarWrapper.base'));
var MobileSidebarWrapper = styled(_Sidebar).withConfig({
  displayName: "styled__MobileSidebarWrapper",
  componentId: "sc-1wthesb-5"
})(["@media screen and (min-width:", "px){display:none;}width:", ";&{", ";}"], function (props) {
  return theme("fannypack.layout." + _get(props, 'theme.fannypack.Page.collapseBreakpoint') + "Breakpoint")(props) + 1;
}, function (props) {
  return props.sidebarWidth || theme('fannypack.Page.WithSidebar.sidebarWidth');
}, theme('fannypack.Page.WithSidebar.MobileSidebarWrapper.base'));
var PageWithSidebar = styled(Flex).withConfig({
  displayName: "styled__PageWithSidebar",
  componentId: "sc-1wthesb-6"
})(["&{", ";}"], theme('fannypack.Page.WithSidebar.base'));
export { DesktopSidebarWrapper, MobileSidebarWrapper, PageContent, PageContentWrapper, PageWithSidebar, Sidebar, Spacer, getWidth };